import {bp} from '../core/namespace.js';

/*****************
 * bp.geoTypeAhead
 */
$.extend(true, bp, {

  geoTypeAhead: (function () {

    var opts = {}
    var typeaheadRetryTimer = null;

    return {
      init: function (custom_opts) {
        custom_opts = typeof custom_opts !== 'undefined' ? custom_opts : {};
        $.extend(true, opts, custom_opts);
        
        
        // search modal is handled directly in the template on search_map_list_base.html
        const selectedUserDisplay = $('#id_user_display'); // : $('#search_data_modal input#id_user_display')
        if (!selectedUserDisplay.length) {
          return;
        }

        // Some geo pages can initialise search before the typeahead plugin finished loading.
        // Guard against hard crashes and retry once after a short delay.
        if (typeof $.fn.typeahead !== 'function') {
          if (typeaheadRetryTimer) {
            clearTimeout(typeaheadRetryTimer);
          }
          typeaheadRetryTimer = setTimeout(function () {
            typeaheadRetryTimer = null;
            bp.geoTypeAhead.init(opts);
          }, 120);
          return;
        }

        selectedUserDisplay.typeahead([{
          name: 'search_suggest',
          remote: '/data/search_suggest.json?q=%QUERY',
          limit: 10
        }]);
        $('.twitter-typeahead .tt-hint').addClass('form-control').addClass('input');
        $('.search-frontpage .twitter-typeahead .tt-hint').removeClass('input-xs').addClass('input-lg').css('background', 'rgba(255,255,255,.8)'); // this is a fix for the frontpage searchbox
        $('.dashboard .twitter-typeahead .tt-hint').removeClass('input-xs').css('background', 'rgba(255,255,255,.8)'); // dashboard typeahead

        // Handle selection from display field (now contains both cities and addresses)
        selectedUserDisplay.on('typeahead:selected typeahead:autocompleted', function (e, item_data) {
          bp.geoTypeAhead.handleTypeaheadSelected(e, item_data);
        });
      },

      /*
      * Handles selection from the display field from either main user_display or search_data_modal user_display
      */
      handleTypeaheadSelected: function (e, item_data, isMobile = false) {
        if (!item_data) return;
        console.log('handleTypeaheadSelected', item_data)

        if (item_data.type === 'address') {
          // ensure initialised
          bp.state.get()
          
          // Switch to address mode
          $('#id_search_mode').val('address');
          $('#search_data_modal #id_search_mode').val('address');
          bp.state.set('search_mode', 'address');

          // Keep city token in hidden cn only (not in visible display)
          var city = item_data.city || (item_data.value && item_data.value.split(',').slice(-1)[0].trim()) || '';

          $('#id_cn').val(city);
          $('#search_data_modal #id_cn').val(city);
          bp.state.set('cn', city);

          // Post full address as hidden field
          var fullAddress = item_data.address || item_data.value || '';
          $('#id_address').val(fullAddress);
          $('#search_data_modal #id_address').val(fullAddress);
          bp.state.set('address', fullAddress);
          
          // Visible display shows full address
          $('#id_user_display').val(fullAddress);
          $('#search_data_modal #id_user_display').val(fullAddress);

          // Clear stale bounds so list requests don't carry old constraints
          try {
            $('#id_bounds').val('');
            $('#search_data_modal #id_bounds').val('');
          } catch (e) { console.debug('clear bounds failed', e) }
          try { bp.state.set('bounds', ''); } catch(e) {console.debug('clear bounds failed', e)}

          // Map focus if llz or lat lng available.
          if (item_data.llz) {
            bp.search.last_llz = item_data.llz;
            bp.maps.jump_to_llz(bp.search.last_llz);
          } else if (item_data.lat && item_data.lng) {
            bp.search.last_llz = [item_data.lat, item_data.lng, 14].join(',');
            bp.maps.jump_to_llz(bp.search.last_llz);
          }
          window.forceFitBounds = true;
        } else if (item_data.type === 'city') {
          
          try {
            bp.state.get()
            
            // set search mode
            $('#id_search_mode').val('city');
            $('#search_data_modal #id_search_mode').val('city');
            bp.state.set('search_mode', 'city');
            
            // set address
            $('#id_address').val('');
            $('#search_data_modal #id_address').val('');
            bp.state.set('address', '');

            // set city
            $('#id_cn').val(item_data.value);
            $('#search_data_modal #id_cn').val(item_data.value);
            bp.state.set('cn', item_data.value);
            
            // Visible display shows city
            $('#id_user_display').val(item_data.value);
            $('#search_data_modal #id_user_display').val(item_data.value);
            if (item_data.llz && item_data.llz !== '') {
              bp.search.last_llz = item_data.llz;
              try {
                bp.maps.jump_to_llz(bp.search.last_llz);
              } catch (e) {
                 console.log('handleTypeaheadSelected  error on jump to llz', e) }
            }
          } catch (e) { console.log('handleTypeaheadSelected  error on city', e) }

        }

        if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {
          if (localStorage.view === 'map') {
            bp.search.map_search(true);
          } else {
            bp.search.hx_search_pagination();
          }
        } else {
          _.debounce(bp.maps.load_markers(), 1200, true);
        }
      }
    }
  })()
});
